export default { SHOW_LEGAL_ENTITY: true };


// WEBPACK FOOTER //
// ./src/featureFlags.ts